<div class="container-fluid">
    <!-- <div class="header-container">
        <div class="page-header">
            <span class="fa fa-credit-card"></span>{{ 'bikeshop.shop_setup.card_headers.whatsapp_integration' |
            translate }}
        </div>
    </div> -->
    <div class="row   justify-content-start mb-2">
        <div class="col-9">
            <span class="iso-header">
                {{'bikeshop.shop_setup.card_headers.whatsapp_integration' | translate}}
            </span>
        </div>
    </div>
    <div class="content">
        

        <div class="sub-header">
            {{"bikeshop.shop_profile.whatsapp_integration.configuration_header" | translate}}
        </div>



        <div>
            <div *ngIf="busy" style="display: block;">
                <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                    animationDuration=".5s">
                </p-progressSpinner>
            </div>


            <div *ngIf="!busy && !hasWhatsappSubscription">
                <div class="row margin-top-16">
                    <div class="col-md-12 no-whatsapp-subscription">
                        {{ "bikeshop.shop_profile.whatsapp_integration.no_whatsapp_subscription" | translate }}
                    </div>
                </div>
                <div class="row margin-top-16">
                    <div class="col-md-3">
                        <div *ngIf="isWorkshop">
                            <button pButton type="submit" class="p-button-raised full-width p-mini" [routerLink]="'/store/manage-subscription'" label="{{'bikeshop.account.manage_account' | translate}}"></button>
                        </div>
                        <div *ngIf="isRentals">
                            <button pButton type="submit" class="p-button-raised full-width p-mini" [routerLink]="'/store/rentals/manage-subscription'" label="{{'bikeshop.account.manage_account' | translate}}"></button>
                        </div>  
                    </div>
                </div>
            </div>

            <div *ngIf="hasWhatsappSubscription && !linkedToWhatsApp && !busy">
                <div class="row margin-top-16">
                    <div class="col-md-12 label">
                        {{ "bikeshop.shop_profile.whatsapp_integration.not_connected_message" | translate }}
                    </div>
                </div>
                <div class="facebook-button-container">
                    <!-- <button (click)="connectWhatsapp()">
                        Login with Facebook
                    </button> -->
                    <button (click)="connectWhatsapp()" class="login-with-meta"
                        [ngClass]="{'disabled': !appID || !configID}">
                        <img src="assets/facebook.png" class="meta-logo">
                        Login with Facebook
                    </button>
                </div>
            </div>
            <div *ngIf="hasWhatsappSubscription && linkedToWhatsApp && !busy">
                <div class="row margin-top-16">
                    <div class="col-md-12 label">
                        {{ "bikeshop.shop_profile.whatsapp_integration.connected_message" | translate }}
                    </div>
                </div>
                <div class="row margin-top-16">
                    <div class="col-md-3"></div>
                    <div class="col-md-3" style="margin-top:auto;margin-bottom:auto;">
                        <button pButton type="submit" class="p-button-raised full-width"
                            label="{{ 'bikeshop.shop_profile.whatsapp_integration.disconnect_from_whatsapp' | translate }}"
                            (click)="disconnectWhatsapp()" [disabled]="busy || disconnecting"></button>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="content margin-top-16" *ngIf="hasWhatsappSubscription && linkedToWhatsApp && storeConfig">
        <div class="row">
            <div class="col-md-3 label">
                {{'bikeshop.shop_profile.whatsapp_integration.select_whatsapp_number' | translate}}:
                <span class="help fa hubtiger-tooltip"
                    pTooltip="{{'bikeshop.shop_profile.whatsapp_integration.select_whatsapp_number_info' | translate}}"></span>
            </div>
            <div class="col-md-3">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon"><i class="fa fa-user"></i></span>
                    <p-dropdown [options]="phoneNumbers" [(ngModel)]="storeConfig.phoneID"
                        optionLabel="display_phone_number" optionValue="id"
                        placeholder="{{'bikeshop.shop_profile.whatsapp_integration.select_whatsapp_number' | translate}}">
                    </p-dropdown>
                </div>
            </div>
        </div>
        <div>
            <div class="row margin-top-16">
                <div class="col-md-3"></div>
                <div class="col-md-3" style="margin-top:auto;margin-bottom:auto;">
                    <button pButton type="submit" class="p-button-raised full-width" *ngIf="!savingNumber"
                        label="{{ 'bikeshop.shop_profile.whatsapp_integration.save_phone_number' | translate }}"
                        (click)="savePhoneNumber()" [disabled]="busy || !storeConfig.phoneID"></button>
                    <div *ngIf="savingNumber" style="display: block;">
                        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4"
                            fill="transparent" animationDuration=".5s">
                        </p-progressSpinner>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="content margin-top-16" id="whatsapp-help" *ngIf="hasWhatsappSubscription">
        <div class="sub-header">{{ 'bikeshop.shop_profile.whatsapp_integration.view_whatsapp_blog' | translate }}</div>
        <div class="margin-top-6"><a href="https://hubtiger.com/hubtiger-whatsapp-integration/" target="_blank">https://hubtiger.com/hubtiger-whatsapp-integration/</a></div>
    </div>

    <div class="content margin-top-16" *ngIf="hasWhatsappSubscription && linkedToWhatsApp && storeConfig">
        <div class="payment-alert" innerHTML="{{ 'bikeshop.shop_profile.whatsapp_integration.payment_warning' | translate }}"></div>
    </div>

    <!-- <div class="content margin-top-16" *ngIf="linkedToWhatsApp && hasPhoneNumber">
        <app-whatsapp-playground></app-whatsapp-playground>
    </div> -->
    <div style="margin-bottom: 32px"></div>

    <div class="margin-top-16" *ngIf="linkedToWhatsApp && hasPhoneNumber">
        <app-whatsapp-initiate-chat-template [isWorkshop]="isWorkshop" [isRentals]="isRentals"></app-whatsapp-initiate-chat-template>
    </div>

    <div class="margin-top-16" *ngIf="linkedToWhatsApp && hasPhoneNumber">
        <app-whatsapp-templates></app-whatsapp-templates>
    </div>

</div>

